export function transformNotes(note) {
  return {
    id: note.id,
    name: note.name,
    description: note.description || '',
    refModel: note.refModel,
    createdBy: note.createdById,
    createdAt: note.createdTime,
    canEdit: note.updatebleOob,
    canDelete: note.deleteableOob,
  }
}

export function transformNotesForServer(note) {
  return {
    id: note.id,
    name: note.name,
    description: note.description,
    refModel: note.refModel,
  }
}
